/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import Header from '@features/header';
import { Route } from 'react-router-dom';
import { RouteErrorBoundary } from '@features/error';
import { AppLayout } from '../../layout/AppLayout';
import React from 'react';
import { AppRouteInterface } from '@g17eco/types/routes';
import { AppHeader } from '@features/header/AppHeader';
import { WaitingComponent } from '../../utils/component';
import WTLogo from '../../images/apps/World_Tracker_logo.svg';
import { worldTrackerRoutes } from './routes';

export const WorldTracker = React.lazy(() => import('./index'));

const worldTrackerAppRoute: AppRouteInterface = {
  appName: 'World Tracker',
  appIcon: WTLogo,
  routes: [worldTrackerRoutes.WORLD_TRACKER],
  hasSidebar: false
}

const component = (props: any) => (
  <Header {...props} className={'responsivePage'}>
    <AppHeader appRoute={worldTrackerAppRoute} route={worldTrackerRoutes.WORLD_TRACKER} />
  </Header>
);


export const WorldTrackerRoute = () => {
  const route = worldTrackerRoutes.WORLD_TRACKER;

  return (
    <RouteErrorBoundary>
      <AppLayout Header={<Route path={route.path} component={component} />}>
        <Route {...worldTrackerRoutes.WORLD_TRACKER}>
          {WaitingComponent(WorldTracker)}
        </Route>
      </AppLayout>
    </RouteErrorBoundary>
  );
}

export default WorldTrackerRoute;
